import IAnalyticsAction from "../IAnalyticsAction";
import {ActionType} from "typesafe-actions";
import {skipQuestion} from "../../../questions/actions";

export default function skipQuestionHandler({ payload }: ActionType<typeof skipQuestion>): IAnalyticsAction | undefined {
    return {
        category: "question",
        object: "answer",
        name: "skip",
        postId: payload.questionId,
        levelId: payload.levelId,
    };
}